import React, { Component } from 'react';
import Box from '../../hoc/Box/Box';
import Collapsible from 'react-collapsible';
import LogLink from '../../components/UI/LogLink/LogLink';
import Modal from '../../components/UI/Modal/Modal';
import Moment from 'react-moment';
import Spinner from '../../components/UI/Spinner/Spinner';
import api from '../../axios-local-api';
import classes from './ChangeLog.css';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
import { FaSync } from 'react-icons/fa'
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from 'react-icons/md';
import { connect } from 'react-redux';
import * as actions from '../../store/actions/index';
import ReactPaginate from 'react-paginate';
import ErrorAlert from '../../shared/Alert/ErrorAlert';


export class ChangeLog extends Component {
  constructor(props) {
    super(props)
    this.state = {
      linkModal: false,
      success: false,
      error: false,
      currentPage: 1,
      itemsPerPage: 10,
      upArrows: false,
    }
    this.handleClick = this.handleClick.bind(this);
  }


  handleClick(value) { this.setState({ currentPage: value }) }

  openHandler() { this.setState({ upArrows: true }) }

  closeHandler() { this.setState({ upArrows: false }) }

  openModal = () => { this.setState({ linkModal: true }) }

  closeModal = () => {
    this.props.onResetLogLink()
    this.setState({ linkModal: false })
  }

  findChangeLogAuthor = (rtccaEvent) => {
    if (rtccaEvent.customerId) return rtccaEvent.customerId

    if (Array.isArray(rtccaEvent.additionalAttributes)) {
      const attribute = rtccaEvent.additionalAttributes.find(x => x.attribute.toLowerCase() === 'requestorid')
      return (attribute && attribute.value) || 'N/A'
    }

    return 'N/A'
  }

  createWscEventDescription = (n, attributes) => {
    try {
      const resultsAttr = attributes.filter(v => v.attribute === 'STATUS')
      const result = resultsAttr[0].value
      return `${n} - ${result}`

    } catch (e) {

      return `${n} - N/A`
    }
  }

  findChangeLogDescription = (event) => {
    const {
      eventType: type,
      eventName: name,
      additionalAttributes: attributesArray
    } = event

    switch (type) {
      case 'WiFi Service Check Run':
        return this.createWscEventDescription(name, attributesArray)
      case 'Pod QoE':
      case 'Device QoE':
      case 'AIHWServiceResume':
      case 'Smart Steering':
        return name
      default:
        return type
    }
  }

  render() {
    if (this.props.logsLink && !this.state.linkModal) this.setState({ linkModal: true })
    if (this.props.error && !this.state.error) {
      this.setState({ error: true, success: false, modal: false });
      this.props.onResetEquipmentErrorSuccess()
    }

    let logList, renderPageNumbers, changesBy, dateAndBy;

    if (this.props.changeLog && this.props.changeLog.length) {
      const { currentPage, itemsPerPage } = this.state;

      // Logic for displaying current rec
      const indexOfLast = currentPage * itemsPerPage;
      const indexOfFirst = indexOfLast - itemsPerPage;
      const currentRecords = this.props.changeLog.slice(indexOfFirst, indexOfLast);

      // Logic for displaying page numbers
      const pageNumbers = [];
      for (let i = 1; i <= Math.ceil(this.props.changeLog.length / itemsPerPage); i++) pageNumbers.push(i)

      if (pageNumbers.length >= 1) {
        renderPageNumbers = (
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <span>{`Showing ${currentPage} of ${pageNumbers.length}`}</span>
            <ReactPaginate
              previousLabel={<MdKeyboardArrowLeft size="25px" />}
              nextLabel={<MdKeyboardArrowRight size="25px" />}
              breakLabel={'...'}
              breakClassName={'break-me'}
              pageCount={pageNumbers.length}
              marginPagesDisplayed={1}
              pageRangeDisplayed={5}
              onPageChange={(value) => { this.handleClick(value.selected + 1) }}
              containerClassName={classes.pagination}
              pageClassName={classes.paginationPage}
              activeClassName={classes.paginationactive}
              disabledClassName={classes.paginationDisable}
            />
          </div>
        )
      }

      if (window.innerWidth < 900) {
        /********************************************
         * !                                      ! *
         * !                                      ! *
         * !  MOBLE RENDERING LOGIC IS DONE HERE  ! *
         * !                                      ! *
         * !                                      ! *
         ********************************************/
        // Logic for displaying author of the changes
        changesBy = currentRecords
          .filter(element => element && element.topic)
          .map((rtccaEvent, ind) => (
            <Box key={ind}>
              <tr>
                <td className={ind === currentRecords.length - 1 ? classes.lastTdTag : ''} style={{ display: 'flex', borderLeft: 'none', padding: '10px', height: 'auto' }}>
                  {this.findChangeLogAuthor(rtccaEvent)}
                </td>
              </tr>
            </Box>
          ))

        // Logic for displaying date and type of the changes
        dateAndBy = currentRecords
          .filter(element => element && element.topic)
          .map((rtccaEvent, ind) => (
            <Box key={ind}>
              <tr>
                <td className={ind === currentRecords.length - 1 ? classes.lastTdTag : ''} style={{ padding: '10px', borderRight: 'none', borderLeft: 'none', height: 'auto' }}>
                  <Moment format="ddd MM/DD/YYYY hh:mm A" date={rtccaEvent.eventTimestamp} />
                </td>
                <td className={ind === currentRecords.length - 1 ? classes.lastTdTag : ''} style={{ padding: '10px', borderRight: 'none', borderLeft: 'none', height: 'auto' }}>
                  {this.findChangeLogDescription(rtccaEvent)}
                </td>
              </tr>
            </Box>
          ))
      }

      // Logic for displaying the author along with the dates and changes
      // (Desktop view uses div's)
      logList = currentRecords
        .filter((element) => element && element.topic)
        .map((rtccaEvent, i) => (
          <Box key={i}>
            <div className={classes.ListHolder}>
              <div className={classes.ListItemOuter}>
                <div className={classes.ListItemLeft}>
                  <div id="ChangedBy" className={classes.ListLeftSide}>
                    {this.findChangeLogAuthor(rtccaEvent)}
                  </div>
                  <div className={classes.ListMiddle}>
                    <div id="DateTime"><Moment format="ddd MM/DD/YYYY hh:mm A">{rtccaEvent.eventTimestamp}</Moment></div>
                  </div>
                  <div className={classes.ListRightSide}>
                    <div id="ChangesMade">{this.findChangeLogDescription(rtccaEvent)}</div>
                  </div>
                </div>
              </div>
            </div>
            <div className={classes.Separator} />
          </Box>
        ))

    } else if(this.props.apiNotFound) {
      logList = (
        <ErrorAlert />
      )
    } else {

      logList = (
        <Box>
          <div style={{ padding: 20, textAlign: 'center' }}>
            No Log Data Available
          </div>
        </Box>
      )
    }

    const arrow =
      this.state.upArrows
        ? <MdKeyboardArrowUp aria-label="arrow up" color={'gray'} size={'30px'} />
        : <MdKeyboardArrowDown aria-label="arrow down" color={'gray'} size={'30px'} />

    const arrowContainer = (
      <Box>
        <div>
          <div className={classes.TitleArea}>
            <div className={classes.TitleLeft}>
              <h3>Change Log</h3>
            </div>
            <button className={classes.OpenCloseButton}>
              {arrow}
            </button>
          </div>
        </div>
      </Box>
    )

    const spinner = (
      <Box>
        <div className={[classes.showDesktop, classes.ChangeLog].join(' ')}>
          <div className={classes.TitleArea}>
            <div className={classes.TitleLeft}>
              <h3>Change Log</h3>
            </div>
          </div>
          <div className={classes.Separator} />
          <div className={classes.BodyArea}>
            <Spinner />
          </div>
        </div>
        <div className={[classes.showMobile, classes.ChangeLog].join(' ')}>
          <Collapsible
            transitionTime={100}
            onOpening={() => { this.openHandler() }}
            onClosing={() => { this.closeHandler() }}
            trigger={arrowContainer}
          >
            <Spinner />
          </Collapsible>
        </div>
      </Box>
    )

    const desktopChangeLog = (
      <div className={[classes.showDesktop, classes.ChangeLog].join(' ')}>
        <div className={classes.TitleArea}>
          <div className={classes.TitleLeft}>
            <h3>Change Log</h3>
          </div>
          <button
            id="loglinkbtn"
            className={classes.RegularButton}
            onClick={this.props.onGetLogLink}
          >
            Get SCP Router Log Link
          </button>
          <button
            id='changeLogRefreshBtn'
            className={classes.RegularButton}
            onClick={() => this.props.refreshLogs()}
          >
            <FaSync />  Refresh
          </button>
        </div>

        <div className={classes.Separator} />

        <div className={classes.BodyArea}>
          <div className={classes.ListHolder}>
            <div className={classes.ListItemOuter}>
              <div className={classes.ListItemLeft}>
                <div className={classes.ListLeftSide}>
                  <b> Changed By </b>
                </div>
                <div className={classes.ListMiddle}>
                  <b>Date & Time</b>
                </div>
                <div className={classes.ListRightSide}>
                  <b>Changes Made</b>
                </div>
              </div>
            </div>
          </div>
          <div>
            {logList}
          </div>
          <div className={classes.tenantDetailsPagination}>
            {renderPageNumbers}
          </div>
        </div>
      </div>
    )

    const mobileChangeLog = (
      <div className={[classes.showMobile, classes.ChangeLog].join(' ')}>
        <Collapsible
          transitionTime={100}
          onOpening={() => { this.openHandler() }}
          onClosing={() => { this.closeHandler() }}
          trigger={arrowContainer}
        >
          <div style={{ margin: '5px', display: 'flex', flexDirection:'row', justifyContent: 'space-between'}}>
            <button
              id="loglinkbtn" style={{ padding: '8px' }}
              className={classes.RegularButton}
              onClick={this.props.onGetLogLink}
            >
              Get SCP Router Log Link
            </button>

            <button
              className={classes.RegularButton}
              onClick={() => this.props.refreshLogs()}
            >
              <FaSync />  Refresh
            </button>
          </div>
          <div style={{ float: 'left' }}>
            <table cellPadding="0" cellSpacing="0">
              <thead>
                <tr>
                  <th style={{ borderLeft: 'none', padding: '12px' }}>Changes By</th>
                </tr>
              </thead>
              <tbody>
                {changesBy}
              </tbody>
            </table>
          </div>

          <div className={classes.tablewrapper}>
            <table cellPadding="0" cellSpacing="0" >
              <thead>
                <tr>
                  <th style={{ borderLeft: 'none', borderRight: 'none', textAlign: 'left', padding: '12px' }}>
                    Date &amp; Time
                  </th>
                  <th style={{ borderLeft: 'none', borderRight: 'none', textAlign: 'left', padding: '12px' }}>
                    Changes Made
                  </th>
                </tr>
              </thead>
              <tbody>
                {dateAndBy}
              </tbody>
            </table>
          </div>
          <div style={{ float: 'right', padding: '5px' }}>
            <span> {renderPageNumbers} </span>
          </div>
        </Collapsible>
      </div>
    )

    return (
      this.props.isLoading === true
        ? spinner
        : (
          <Box >
            {desktopChangeLog}

            {mobileChangeLog}

            {
              this.state.linkModal &&
              <Modal showCloseIcon show={this.state.linkModal} modalClosed={this.closeModal}>
                <LogLink logsLink={this.props.logsLink} />
              </Modal>
            }
          </Box>
        )
    )
  }
}

const mapStateToProps = (state) => (
  {
    loaded: state.settings.loaded,
    loading: state.settings.loading,
    account: state.settings.account,
    isPinxt: state.auth.pToken !== null,
    logsLink: state.logs.logsLink,
    changeLog: state.logs.logsList,
    isLoading: state.logs.loading,
    realSettings: state.settings.realSettings,
    isAuthenticated: state.auth.token !== null,
    apiNotFound: state.logs.apiNotFound
  }
)

const mapDispatchToProps = (dispatch) => (
  {
    refreshLogs: () => dispatch(actions.initLogs()),
    onGetLogLink: () => dispatch(actions.getLogLink()),
    onResetLogLink: () => dispatch(actions.setLogLink(null)),
  }
)

export default connect(mapStateToProps, mapDispatchToProps)(withErrorHandler(ChangeLog, api));
